import {useTranslation} from 'react-i18next';
import {useSearchURL, useSelectedDocContext} from '../../../../search-hooks';
import {DefaultRootState, useSelector} from 'react-redux';
import React, {memo} from 'react';
import classNames from 'clsx';
import {buildDefaultFieldTitle, formatBytes, isEmptyArray} from '../../../../../utils/utils';
import {Translations} from '../../../../../backendTranslations/backendTranslations-types';
import {EditableTag} from '../../../../../common/editable-tag/editableTag';
import {constructLink, getFieldNamesFromFacets} from '../details.utils';
import {HibuFacetGroup} from '../../../../../facets/facet.types';
import {useFacets} from '../../../../../facets/duck/filter.hooks';

export const MetadataList = memo(() => {
    const {t} = useTranslation();
    const searchConfig = useSelector((state: DefaultRootState) => state.config.uiConfig.search);
    const facets: HibuFacetGroup[] = useFacets();
    const selectedDoc = useSelectedDocContext();
    const translations: Translations = useSelector((state: DefaultRootState) => state.translations);
    const searchURL = useSearchURL();

    if (!selectedDoc) {
        return null;
    }

    const metadataFromFacets: string[] = getFieldNamesFromFacets(facets, 'metadata');

    const showValue = (val: string, fieldName: string, key: string) => {
        let translationName = fieldName;
        if (fieldName.endsWith('_bool')) {
            translationName = 'boolean';
        }
        const translatedValue = translations.translations?.[translationName]?.[val];
        let value = translatedValue || val;
        if (translationName === 'metadata.filesize_long') {
            value = formatBytes(value, t);
        }
        return (
            <EditableTag
                key={key}
                fieldType="line"
                value={value}
                onSubmit={() => console.log('not needed')}
                onUserValidation={() => console.log('not needed')}
                onDelete={() => console.log('not needed')}
                onCancel={() => console.log('not needed')}
                allowEditing={false}
                valueLink={constructLink(fieldName, val, searchURL)}
            />
        );
    };

    const showMetadata = (metadataName: string) => {
        const metadataValue = selectedDoc.metadata[metadataName];
        if (metadataValue === undefined || metadataName === '') return;

        const fieldName = 'metadata.' + metadataName;
        const componentKey = 'metadata.' + metadataName + '-value';
        return (
            <div className="document-tag" key={metadataName}>
                <div className="tag-name cell">
                    {t('fieldTitle.metadata.' + metadataName + '.label', buildDefaultFieldTitle(metadataName))}
                </div>
                <div className="tag-value cell" key={'metadata' + metadataName}>
                    {Array.isArray(metadataValue) ? (
                        <>{metadataValue.map((value, i) => showValue(value, metadataName, componentKey + i))}</>
                    ) : (
                        showValue(metadataValue, fieldName, componentKey)
                    )}
                </div>
            </div>
        );
    };

    const showMetadataFromConfig = searchConfig.detailFields?.detailMetadata?.map((metadataName: string) => {
        return <>{showMetadata(metadataName)}</>;
    });

    const showMetadataFromFacets = metadataFromFacets.map((metadataFacet: string) => {
        // Only metadata, that is present in facets are considered. Default, if detailFields array from the config is empty.
        const metadataName = metadataFacet.substring(metadataFacet.indexOf('.') + 1);
        return <>{showMetadata(metadataName)}</>;
    });

    return (
        <div className={classNames('document-infos', 'metadata-tags')}>
            {isEmptyArray(searchConfig.detailFields?.detailMetadata) ? showMetadataFromFacets : showMetadataFromConfig}
        </div>
    );
});
